import { Component } from '@angular/core';

@Component({
  selector: 'uni-nav-back',
  templateUrl: './uni-nav-back.component.html',
  styleUrls: ['./uni-nav-back.component.scss']
})
export class UniNavBackComponent {}
